"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HTTPRequestMethod;
(function (HTTPRequestMethod) {
    HTTPRequestMethod["GET"] = "GET";
    HTTPRequestMethod["POST"] = "POST";
})(HTTPRequestMethod = exports.HTTPRequestMethod || (exports.HTTPRequestMethod = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
    Currency["JPY"] = "JPY";
})(Currency = exports.Currency || (exports.Currency = {}));
var Language;
(function (Language) {
    Language["en_US"] = "en_US";
    Language["en_GB"] = "en_GB";
    Language["de_DE"] = "de_DE";
    Language["fr_FR"] = "fr_FR";
    Language["it_IT"] = "it_IT";
    Language["es_ES"] = "es_ES";
    Language["ja_JP"] = "ja_JP";
})(Language = exports.Language || (exports.Language = {}));
var AuthorizationInteractive;
(function (AuthorizationInteractive) {
    AuthorizationInteractive["auto"] = "auto";
    AuthorizationInteractive["always"] = "always";
    AuthorizationInteractive["never"] = "never";
})(AuthorizationInteractive = exports.AuthorizationInteractive || (exports.AuthorizationInteractive = {}));
var AuthorizationResponseType;
(function (AuthorizationResponseType) {
    AuthorizationResponseType["token"] = "token";
    AuthorizationResponseType["code"] = "code";
})(AuthorizationResponseType = exports.AuthorizationResponseType || (exports.AuthorizationResponseType = {}));
var AuthorizationStatus;
(function (AuthorizationStatus) {
    AuthorizationStatus["queued"] = "queued";
    AuthorizationStatus["progress"] = "progress";
    AuthorizationStatus["complete"] = "complete";
})(AuthorizationStatus = exports.AuthorizationStatus || (exports.AuthorizationStatus = {}));
var AuthorizationError;
(function (AuthorizationError) {
    AuthorizationError["access_denied"] = "access_denied";
    AuthorizationError["invalid_grant"] = "invalid_grant";
    AuthorizationError["invalid_request"] = "invalid_request";
    AuthorizationError["invalid_scope"] = "invalid_scope";
    AuthorizationError["server_error"] = "server_error";
    AuthorizationError["temporarily_unavailable"] = "temporarily_unavailable";
    AuthorizationError["unauthorized_client"] = "unauthorized_client";
})(AuthorizationError = exports.AuthorizationError || (exports.AuthorizationError = {}));
var ButtonPlacement;
(function (ButtonPlacement) {
    ButtonPlacement["Home"] = "Home";
    ButtonPlacement["Product"] = "Product";
    ButtonPlacement["Cart"] = "Cart";
    ButtonPlacement["Checkout"] = "Checkout";
    ButtonPlacement["Other"] = "Other";
})(ButtonPlacement = exports.ButtonPlacement || (exports.ButtonPlacement = {}));
var ProductType;
(function (ProductType) {
    ProductType["PayAndShip"] = "PayAndShip";
    ProductType["PayOnly"] = "PayOnly";
    ProductType["SignIn"] = "SignIn";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Gold"] = "Gold";
    ButtonColor["LightGray"] = "LightGray";
    ButtonColor["DarkGray"] = "DarkGray";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));
var ChangeAction;
(function (ChangeAction) {
    ChangeAction["changeAddress"] = "changeAddress";
    ChangeAction["changePayment"] = "changePayment";
})(ChangeAction = exports.ChangeAction || (exports.ChangeAction = {}));
var AppPage;
(function (AppPage) {
    AppPage["checkout"] = "checkout";
    AppPage["invalid_payment"] = "invalid_payment";
    AppPage["logout"] = "logout";
    AppPage["redirect"] = "redirect";
})(AppPage = exports.AppPage || (exports.AppPage = {}));
var Role;
(function (Role) {
    Role["payButton"] = "pay-button";
    Role["checkoutButton"] = "checkout-button";
    Role["pdpPayButton"] = "pdp-pay-button";
    Role["loginButton"] = "login-button";
    Role["changeAddress"] = "change-address";
    Role["changePayment"] = "change-payment";
    Role["selectShippingMethod"] = "select-shipping-method";
    Role["orderReview"] = "order-review";
    Role["pleaseWait"] = "please-wait";
    Role["submitOrder"] = "submit-order";
    Role["couponForm"] = "coupon-form";
    Role["couponApplyButton"] = "coupon-apply-button";
    Role["couponCancelButton"] = "coupon-cancel-button";
    Role["customFields"] = "custom-fields";
})(Role = exports.Role || (exports.Role = {}));
